import { Site } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { TXTWCL_ADM_ID } from './RegulatorBetId.messages.json';

interface Props {
  regulatorId: string;
}
const translationMapping: Partial<Record<Site, TranslationTag>> = {
  [Site.IT]: TXTWCL_ADM_ID
};

export const RegulatorBetId: React.FC<Props> = ({ regulatorId }) => {
  const site = useSelector(select.cms.getSiteId);
  const translation = translationMapping[site];

  if (!translation) {
    return null;
  }

  return (
    <>
      <Translation {...translation} />: {regulatorId.toUpperCase()}
    </>
  );
};

export default RegulatorBetId;
